import { TextInput } from '@/components/Form/TextInput';

import { AMOUNT_PATTERN } from '@/constants/patterns';

import { useTranslate } from '@/hooks/useTranslate';

import { QuestionProps } from '../QuestionDrawer.interface';
import { useRemediationAccountForm } from './hook/useRemediationAccountForm';
import {
  AccountSectionFormProps,
  RemediationAccountQuestionForm,
} from './RemediationAccountQuestionForm';

import {
  FormFieldContainer,
  QuestionLabel,
} from '../QuestionAboutMultipleMonthlyDeposit.styled';

type AccountFields = { monthlyDepositAmount: string };

export function RemediationQuestionExpectedMonthlyDeposits({
  onAnswered,
  ...props
}: Readonly<QuestionProps>) {
  const { t } = useTranslate();

  const formState = useRemediationAccountForm<AccountFields>({
    defaultAccountValues: { monthlyDepositAmount: '' },
    toDepositInfo: (_account, fields) => ({
      estimatedMonthlyDepositAmount: Number.parseFloat(
        fields.monthlyDepositAmount,
      ),
    }),
    onFinished: onAnswered,
  });

  return (
    <RemediationAccountQuestionForm
      {...props}
      {...formState}
      submitLabel={t(
        'questionDrawer.remediationExpectedMonthlyDeposits.button.proceed',
      )}
      AccountSectionForm={ExpectedMonthlyDepositSectionForm}
    />
  );
}

function ExpectedMonthlyDepositSectionForm({
  account,
  index,
  control,
  fieldErrors,
  isPending,
}: AccountSectionFormProps<AccountFields>) {
  const { t } = useTranslate();

  return (
    <FormFieldContainer>
      <QuestionLabel>
        {t('questionDrawer.remediationExpectedMonthlyDeposits.label')}
      </QuestionLabel>
      <TextInput
        type="text"
        control={control}
        name={`accounts.${index}.monthlyDepositAmount`}
        error={!!fieldErrors.accounts?.[index]?.monthlyDepositAmount}
        helperText={
          fieldErrors.accounts?.[index]?.monthlyDepositAmount?.message
        }
        rules={{
          required: t(
            'questionDrawer.remediationExpectedMonthlyDeposits.required',
          ),
          pattern: {
            value: new RegExp(AMOUNT_PATTERN),
            message: t(
              'questionDrawer.remediationExpectedMonthlyDeposits.pattern',
            ),
          },
        }}
        placeholder={t(
          'questionDrawer.remediationExpectedMonthlyDeposits.placeholder',
        )}
        inputMode="numeric"
        autoComplete="off"
        disabled={isPending}
        template="currency"
        startAdornment={account.currency}
      />
    </FormFieldContainer>
  );
}
